module.exports = __webpack_public_path__ + "img/screenshot-white.4ab44cb2.png";